import $ from 'jquery'
import { each } from '../util'

/**
 * @module Selectize
 * NOTE: JQuery dependency, do not import in main.js.
 */
const Selectize = (() => {
  const initializeSelect = (select) => {
    $(select).selectize({})
  }

  const initializeSelectCreates = (select) => {
    $(select).selectize({
      persist: false,
      create: (input) => ({value: input, text: input})
    })
  }

  const initializeSelectTags = (select) => {
    $(select).selectize({
      delimiter: ',',
      persist: false,
      create: (input) => ({value: input, text: input}),
      options: JSON.parse(select.getAttribute('data-options')).map((o) => ({ value: o, text: o }))
    })
  }

  const init = () => {
    const selects = document.querySelectorAll('.js-selectize')
    if (selects && selects.length > 0) {
      each(selects, (i, select) => initializeSelect(select))
    }

    const selectsCreates = document.querySelectorAll('.js-selectize-creates')
    if (selectsCreates && selectsCreates.length > 0) {
      each(selectsCreates, (i, select) => initializeSelectCreates(select))
    }

    const selectsTags = document.querySelectorAll('.js-selectize-tags')
    if (selectsTags && selectsTags.length > 0) {
      each(selectsTags, (i, select) => initializeSelectTags(select))
    }
  }

  return {
    init
  }
})()

export default Selectize



// WEBPACK FOOTER //
// app/javascript/scripts/components/Selectize.js